// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"AgreementPage7_disclaimer__cCvJN"};